module.exports = __webpack_public_path__ + "img/touxiang-big.85ae6023.png";